module.exports = __webpack_public_path__ + "img/bolt-3d.1f5137f0.png";